/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnproxiedMcpServerUsageBreakdownPayload,
  UnproxiedMcpServerUsageBreakdownPayload$Outbound,
  UnproxiedMcpServerUsageBreakdownPayload$outboundSchema,
} from "../components/unproxiedmcpserverusagebreakdownpayload.js";

export type GetUnproxiedMcpServerClientUsageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUnproxiedMcpServerClientUsageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUnproxiedMcpServerClientUsageSecurity = {
  option1?: GetUnproxiedMcpServerClientUsageSecurityOption1 | undefined;
  option2?: GetUnproxiedMcpServerClientUsageSecurityOption2 | undefined;
};

export type GetUnproxiedMcpServerClientUsageRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  unproxiedMcpServerUsageBreakdownPayload:
    UnproxiedMcpServerUsageBreakdownPayload;
};

/** @internal */
export type GetUnproxiedMcpServerClientUsageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUnproxiedMcpServerClientUsageSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerClientUsageSecurityOption1$Outbound,
    GetUnproxiedMcpServerClientUsageSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getUnproxiedMcpServerClientUsageSecurityOption1ToJSON(
  getUnproxiedMcpServerClientUsageSecurityOption1:
    GetUnproxiedMcpServerClientUsageSecurityOption1,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerClientUsageSecurityOption1$outboundSchema.parse(
      getUnproxiedMcpServerClientUsageSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerClientUsageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUnproxiedMcpServerClientUsageSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerClientUsageSecurityOption2$Outbound,
    GetUnproxiedMcpServerClientUsageSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getUnproxiedMcpServerClientUsageSecurityOption2ToJSON(
  getUnproxiedMcpServerClientUsageSecurityOption2:
    GetUnproxiedMcpServerClientUsageSecurityOption2,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerClientUsageSecurityOption2$outboundSchema.parse(
      getUnproxiedMcpServerClientUsageSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerClientUsageSecurity$Outbound = {
  Option1?:
    | GetUnproxiedMcpServerClientUsageSecurityOption1$Outbound
    | undefined;
  Option2?:
    | GetUnproxiedMcpServerClientUsageSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const GetUnproxiedMcpServerClientUsageSecurity$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerClientUsageSecurity$Outbound,
    GetUnproxiedMcpServerClientUsageSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetUnproxiedMcpServerClientUsageSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetUnproxiedMcpServerClientUsageSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getUnproxiedMcpServerClientUsageSecurityToJSON(
  getUnproxiedMcpServerClientUsageSecurity:
    GetUnproxiedMcpServerClientUsageSecurity,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerClientUsageSecurity$outboundSchema.parse(
      getUnproxiedMcpServerClientUsageSecurity,
    ),
  );
}

/** @internal */
export type GetUnproxiedMcpServerClientUsageRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UnproxiedMcpServerUsageBreakdownPayload:
    UnproxiedMcpServerUsageBreakdownPayload$Outbound;
};

/** @internal */
export const GetUnproxiedMcpServerClientUsageRequest$outboundSchema:
  z.ZodMiniType<
    GetUnproxiedMcpServerClientUsageRequest$Outbound,
    GetUnproxiedMcpServerClientUsageRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      unproxiedMcpServerUsageBreakdownPayload:
        UnproxiedMcpServerUsageBreakdownPayload$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        unproxiedMcpServerUsageBreakdownPayload:
          "UnproxiedMcpServerUsageBreakdownPayload",
      });
    }),
  );

export function getUnproxiedMcpServerClientUsageRequestToJSON(
  getUnproxiedMcpServerClientUsageRequest:
    GetUnproxiedMcpServerClientUsageRequest,
): string {
  return JSON.stringify(
    GetUnproxiedMcpServerClientUsageRequest$outboundSchema.parse(
      getUnproxiedMcpServerClientUsageRequest,
    ),
  );
}
